import { TRATAMIENTOS } from '../services/tratamientos';

// Distribución temporal de citas. Las horas se calculan en horario local.
export const HORA_INICIO = 9;
export const HORA_FIN = 22;
export const PX_HORA = 60;
// Reserva visual mínima para mostrar el nombre sin invadir otras citas.
// No modifica la duración almacenada ni las horas que se muestran.
export const ALTURA_MINIMA_CITA = 22;
const MINUTOS_VISUALES = ALTURA_MINIMA_CITA * 60 / PX_HORA;

export function mismaFecha(a, b) {
  return a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

export function citasDelDia(citas, fecha) {
  return citas.filter(c => mismaFecha(new Date(c.fechaInicio), fecha));
}

function normalizar(citas) {
  return citas.map((c, index) => {
    const inicio = new Date(c.fechaInicio);
    const start = inicio.getHours() * 60 + inicio.getMinutes();
    const duracion = Math.max(1, Number(c.duracionMin) || 1);
    return { cita: c, index, start, end: start + duracion, visualEnd: start + Math.max(duracion, MINUTOS_VISUALES) };
  }).filter(c => Number.isFinite(c.start))
    .sort((a, b) => a.start - b.start || b.visualEnd - a.visualEnd || a.index - b.index);
}

function crearGrupo(items) {
  // Asignación greedy de carriles a intervalos: reutilizar siempre carril libre.
  const finCarriles = [];
  const eventos = items.map(item => {
    let col = finCarriles.findIndex(fin => fin <= item.start);
    if (col < 0) col = finCarriles.length;
    finCarriles[col] = item.visualEnd;
    return { ...item, col };
  });
  const columnas = finCarriles.length;
  // Expandir cada cita hacia la derecha solo si no ocupa espacio de otra cita.
  return {
    inicio: Math.min(...items.map(i => i.start)),
    fin: Math.max(...items.map(i => i.end)),
    finVisual: Math.max(...items.map(i => i.visualEnd)),
    columnas,
    eventos: eventos.map(item => {
      let span = 1;
      for (let col = item.col + 1; col < columnas; col++) {
        if (eventos.some(other => other.col === col &&
          item.start < other.visualEnd && item.visualEnd > other.start)) break;
        span++;
      }
      return { ...item, span };
    })
  };
}

// Agrupa componentes temporales conectados (A se cruza con B, B con C).
// Es importante ordenar ANTES de agrupar para no separar componentes vinculados.
export function distribuirCitas(citas) {
  const ordenadas = normalizar(citas);
  const grupos = [];
  let actual = [];
  let ultimoFin = -Infinity;
  ordenadas.forEach(item => {
    if (actual.length && item.start >= ultimoFin) {
      grupos.push(crearGrupo(actual));
      actual = [];
      ultimoFin = -Infinity;
    }
    actual.push(item);
    ultimoFin = Math.max(ultimoFin, item.visualEnd);
  });
  if (actual.length) grupos.push(crearGrupo(actual));
  return grupos;
}

export function posicionCita(item, columnas, compacta = false) {
  const anchoColumna = 100 / columnas;
  return {
    top: (item.start - HORA_INICIO * 60) * PX_HORA / 60,
    height: Math.max(ALTURA_MINIMA_CITA, (item.end - item.start) * PX_HORA / 60),
    left: `calc(${item.col * anchoColumna}% + 2px)`,
    width: `calc(${item.span * anchoColumna}% - 4px)`,
    ...(compacta ? { minWidth: 0 } : {})
  };
}

export function horaTexto(minutos) {
  const h = Math.floor(minutos / 60) % 24;
  const m = minutos % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

export function colorFondoCita(cita) {
  if (cita.profesional === 'LIS') {
    if (cita.clinica === 'VEN') return '#86efac';
    if (cita.clinica === 'ELIPA') return '#c084fc';
  }
  return { ELIPA: '#59b3f8a4', VEN: '#fce3aeff' }[cita.clinica] || '#f5faff';
}

const normalizarTratamiento = valor => String(valor || '')
  .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .trim().toUpperCase().replace(/\s+/g, ' ');

// El catálogo es la referencia, también para las citas creadas hace tiempo.
export function colorBordeCita(cita) {
  const tratamiento = normalizarTratamiento(cita.tratamiento);
  const definido = TRATAMIENTOS.find(t =>
    normalizarTratamiento(t.label) === tratamiento ||
    normalizarTratamiento(t.value) === tratamiento
  );
  return definido?.color || cita.color || '#1890ff';
}
